import { ReactNode } from "react";
import { StepPayloadPreviewProvider } from "@/components/form/step-payload-preview-context";
import { processTypeFromContext } from "@/shared/process-from-context";
import { TaskType } from "@/types";
import { StepContainer } from "./step-container";

type StepShellProps = {
	taskType: TaskType;
	flowPayload?: unknown;
	children: ReactNode;
	gap?: number;
};

/**
 * Renders a step's content and reports the step to the flow layout's progress
 * header, which stays put while only the content below animates.
 */
export const StepShell = ({
	taskType,
	flowPayload,
	children,
	gap,
}: StepShellProps) => {
	return (
		<StepPayloadPreviewProvider value={flowPayload}>
			<StepContainer
				gap={gap}
				taskType={taskType}
				processType={processTypeFromContext(flowPayload)}
			>
				{children}
			</StepContainer>
		</StepPayloadPreviewProvider>
	);
};
